import React, { useEffect, useMemo, useState } from "react";
import TextMedium from "../TextComponent/TextMedium";
import { ReactComponent as ColumnFilterIcon } from "../../../build/images/icons/ColumnFilterIcon.svg";
import { ReactComponent as MessengerIcon } from "../../../build/images/icons-channels/messenger.svg";
import { ReactComponent as WhatsappIcon } from "../../../build/images/icons-channels/whatsapp-large.svg";
import { ReactComponent as WhatsappVoiceIcon } from "../../../build/images/whatsapp_voice.svg";
import { ReactComponent as FacebookIcon } from "../../../build/images/icons-channels/facebook.svg";
import { ReactComponent as VozIcon } from "../../../build/images/icons-channels/voz-large.svg";
import { ReactComponent as EmailIcon } from "../../../build/images/icons-channels/email.svg";
import { ReactComponent as WebchatIcon } from "../../../build/images/icons-channels/webchat-large.svg";
import { ReactComponent as TelegramIcon } from "../../../build/images/icons-channels/telegram-large.svg";
import { ReactComponent as GOOGLEGBM } from "../../../build/images/icons-channels/googlegbm-large.svg";
import { ReactComponent as InstaIcon } from "../../../build/images/icons-channels/instagram-large.svg";
import { ReactComponent as TEAMS } from "../../../build/images/channelsNew/teamsBig.svg";

import { ReactComponent as ClockIcon } from "../../../build/images/viewactionclock.svg";
import { ReactComponent as MessageIcon } from "../../../build/images/viewactionmessage.svg";
import { ReactComponent as CallIcon } from "../../../build/images/viewactioncall.svg";
import { ReactComponent as SussurroIcon } from "../../../build/images/viewactionprofile.svg";
import { ReactComponent as EyeIcon } from "../../../build/images/viewactioneye.svg";
import { ReactComponent as MonitorIcon } from "../../../build/images/viewactionescuta.svg";
import { ReactComponent as PointMessageIcon } from "../../../build/images/viewactionmessagepoint.svg";
import { ReactComponent as BlockIcon } from "../../../build/images/viewactionblock.svg";
import { ReactComponent as ListeningIcon } from "../../../build/images/viewactionescuta.svg";
import TimeCounterInternal from "../../../containers/TimeCounterInternalDash";

import PopoverColumnsFilter from "../../popovercolumnsfilter/PopoverColumnsFilter";
import Table from "../../table";
import { Tooltippy, PopoverDashboard } from "../../../actions/Tippy";
import { ReactComponent as EmptyState } from "../../../build/images/emptystatemanagerhorizontal.svg";
import LoadingTable from "../../../build/images/Column.png";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  addChat,
  addChatSimult,
  typingadd,
  AlterScreen,
  ShowInfoDisplay,
  clearConferenceExt,
  CallConsultaInterna,
  addMonitoring,
  addMonitoringSimult,
  EditTypeMonitorings,
  EditTypeMonitoringm,
} from "../../../actions";
import { InitialMonitoring, SharedScreen } from "../../../actions/websocket";
import BlockUnBlockUserModal from "../../modals/BlockUnBlockUserModal";
import axios from "axios";
import MicroModal from "micromodal";
import { connection_platform } from "../../../services/api";
import testJson from "../../../actions/testJson";
import TimeCounterMinute from "../../../containers/TimeCounterMinute";

let columns = [];
let exhibColumn = [];
let TimeFormat = require("hh-mm-ss");
let colaboratorsDataFiltered = [];
let codeStatus = [];
var port = localStorage.getItem("port");
var pathname = localStorage.getItem("pathname");

function defaultSorting(rowA, rowB, columnId) {
  const objectRowA = rowA.original[columnId].data;
  const objectRowB = rowB.original[columnId].data;

  if (objectRowA > objectRowB) return -1;
  if (objectRowB > objectRowA) return 1;

  return 0;
}

function defaultSortingCase(rowA, rowB, columnId) {
  const objectRowA = rowA.original[columnId].config.customOrder.toLowerCase();
  const objectRowB = rowB.original[columnId].config.customOrder.toLowerCase();

  if (objectRowA > objectRowB) return -1;
  if (objectRowB > objectRowA) return 1;

  return 0;
}

function chooseDisplay(nameDisplay) {
  const indexFind = exhibColumn.findIndex(
    (column) => column.title.toLowerCase() === nameDisplay.toLowerCase(),
  );

  return exhibColumn[indexFind].exhib;
}

export default function CardTableColaborator({ title }) {
  const columnsAllColaborators = useSelector(
    (state) => state.columnsallcolaborators,
  );
  const usersReduce = useSelector((state) => state.agents);
  const [usersRefactored, setUsersRefactored] = useState([]);
  const LoginCompleteReducer = useSelector((state) => state.ipcurrent);
  const FiltersManager = useSelector((state) => state.filtersmanager);
  const ChatSimult = useSelector((state) => state.chatsimult);
  const InfoUsers = useSelector((state) => state.informationusers);
  const MonitoringSimult = useSelector((state) => state.monitoringsimult);
  const [horaaction, setHoraAction] = useState("");
  const [duration, setDuration] = useState("");
  const [reasonaction, setReasonAction] = useState("");
  const [userout, setUserOut] = useState("");
  const [inable, setInable] = useState(false);
  const [act, setAct] = useState("1");
  const [idsup, setIdSup] = useState("");
  const [idblock, setIdBlock] = useState("");
  const [actdesb, setActDesb] = useState("1001");
  const GroupsPermissionSupervisor = useSelector(
    (state) => state.grouppermissionsupervisor,
  );

  const dispatch = useDispatch();

  const InitialChat = (user) => {
    reduxChatInitial(
      parseInt(user.iduser),
      user.label,
      true,
      false,
      user.ramal,
    );
  };

  const reduxChatInitial = (iduser, displayname, active, opencall, ramal) => {
    let datatime = moment().format("YYYY/MM/DD HH:mm:ss");
    dispatch(
      addChatSimult(iduser, displayname, active, opencall, ramal, datatime),
    );
    dispatch(addChat(iduser, displayname, active, opencall, ramal, datatime));
    dispatch(typingadd(iduser, displayname));
    document.getElementById("simulation_click").click();
    // dispatch(AlterScreen('Atendentes'))
    // dispatch(ShowInfoDisplay('Atendentes'))
  };

  const InitialCall = (chatsimult, user) => {
    let erro = 0;

    if (chatsimult.length != 0) {
      chatsimult.map((chat) => {
        if (
          parseInt(chat.iduserout) === parseInt(user.iduser) &&
          chat.voz === false
        ) {
          erro = 1;
        } else if (
          parseInt(chat.iduserout) === parseInt(user.iduser) &&
          chat.voz === true
        ) {
          erro = 2;
        } else if (erro != 1 || erro != 2) {
          erro = 0;
        }
      });
      if (erro === 1) {
        reduxCallInitial(
          parseInt(user.iduser),
          user.label,
          user.ramal,
          user,
          true,
        );
      } else if (erro === 2) {
        console.log("JA POSSUI CHAT ATIVO COM VOZ");
      } else {
        reduxCallInitial(
          parseInt(user.iduser),
          user.label,
          user.ramal,
          user,
          false,
        );
      }
    } else {
      reduxCallInitial(
        parseInt(user.iduser),
        user.label,
        user.ramal,
        user,
        false,
      );
    }
  };

  const reduxCallInitial = (iduser, label, ramal, user, isConference) => {
    if (isConference) {
      dispatch(clearConferenceExt());
      dispatch(CallConsultaInterna(ramal, iduser, user));
      // dispatch(AlterScreen('Atendentes'))
      // dispatch(ShowInfoDisplay('Atendentes'))
    } else {
      reduxChatInitial(iduser, label, true, false, ramal);
      dispatch(CallConsultaInterna(ramal, iduser, user));
    }
    document.getElementById("simulation_click").click();
  };

  const InitialMonitoringAction = (
    userin,
    userout,
    name,
    monitoringsimult,
    line,
    ramal,
  ) => {
    let erro = 0;
    let auxline;
    if (monitoringsimult.length != 0) {
      monitoringsimult.map((monitoring) => {
        if (parseInt(monitoring.userout) === parseInt(userout)) {
          erro = 1;
          auxline = monitoring.line;
        } else if (erro != 1) {
          erro = 0;
        }
      });
      if (erro === 1) {
        if (auxline != line) {
          editTypeMonitoring(userout, line);
        }
      } else {
        reduxMonitoringInitial(userin, userout, name, line, ramal);
      }
    } else {
      reduxMonitoringInitial(userin, userout, name, line, ramal);
    }
    dispatch(ShowInfoDisplay("Monitorias"));
    dispatch(AlterScreen("Monitorias"));
  };

  const reduxMonitoringInitial = (userin, userout, name, line, ramal) => {
    dispatch(ShowInfoDisplay("Monitorias"));
    dispatch(AlterScreen("Monitorias"));
    dispatch(addMonitoring(userout, name, line, ramal));
    dispatch(addMonitoringSimult(userout, name, line, ramal));
    if (line != "4") {
      const socket = InitialMonitoring(userin, userout, line, ramal);
    } else {
      const socket = SharedScreen(ramal);
    }
  };

  const editTypeMonitoring = (userout, line) => {
    dispatch(EditTypeMonitorings(userout, line));
    dispatch(EditTypeMonitoringm(userout, line));
    dispatch(ShowInfoDisplay("Monitorias"));
    dispatch(AlterScreen("Monitorias"));
  };

  const showModal = (userout, action, reasonaction, duration, status) => {
    if (action === "BQSUPER") {
      MicroModal.show("modal__desbloqueio");
      duration = duration.split(" ");
      let horaaction = duration[1].split("-");
      horaaction = horaaction[0];
      duration = duration[0];
      setReasonAction(reasonaction);
      setDuration(duration);
      setHoraAction(horaaction);
      setAct("1001");
      setActDesb("1001");
      setInable(false);
    } else {
      if (status !== null) {
        MicroModal.show("modal__bloqueio");
        setUserOut(userout);
        setAct("1");
        setInable(false);
      } else {
        axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/checkuserblock?iduser=${userout}`,
          )
          .then((response) => {
            if (response.data.durationblock === 0) {
              var idreturnblockdescription = response.data.id;
              axios
                .get(
                  `${connection_platform.type_connect}://${pathname}:${port}/conn/checkuserblocksup?iduser=${userout}`,
                )
                .then((response) => {
                  MicroModal.show("modal__desbloqueio");
                  setInable(true);
                  duration = response.data.blockingdate.split("T");
                  let horaaction = duration[1].split("-");
                  horaaction = horaaction[0];
                  duration = duration[0];
                  duration = moment(duration, "YYYY-MM-DD").format(
                    "DD/MM/YYYY",
                  );
                  setUserOut(userout);
                  setHoraAction(horaaction);
                  setDuration(duration);
                  setReasonAction(response.data.blockingreason);
                  setIdBlock(idreturnblockdescription);
                  setIdSup(response.data.id);
                })
                .catch((error) => {
                  console.log("trycatch");
                });
            } else {
              setUserOut(userout);
              setAct(act);
              setInable(true);
              MicroModal.show("modal__bloqueio");
            }
          })
          .catch((error) => {
            console.log("trycatch");
          });
      }
    }
  };

  const renderPopover = (e, name) => (
    <span className="action-label">{name}</span>
  );

  const renderHandleActions = (user) => (
    <div className="popover__action-dashboard-screen">
      <div
        className="popover__dashboard-screen__labels second"
        onClick={() => InitialChat(user)}
      >
        <li>
          <MessageIcon />
        </li>
        <li>
          <span>Iniciar conversa</span>
        </li>
      </div>
      <div
        className="popover__dashboard-screen__labels second"
        onClick={() => InitialCall(ChatSimult, user)}
      >
        <li>
          <CallIcon />
        </li>
        <li>
          <span>Falar com atendente</span>
        </li>
      </div>
      <div
        className="popover__dashboard-screen__labels second"
        onClick={() =>
          InitialMonitoringAction(
            InfoUsers.id,
            user.iduser,
            user.label,
            MonitoringSimult,
            "1",
            user.ramal,
          )
        }
      >
        <li>
          <ListeningIcon />
        </li>
        <li>
          <span>Escuta sigilosa</span>
        </li>
      </div>
      <div
        className="popover__dashboard-screen__labels second"
        onClick={() =>
          InitialMonitoringAction(
            InfoUsers.id,
            user.iduser,
            user.label,
            MonitoringSimult,
            "2",
            user.ramal,
          )
        }
      >
        <li>
          <SussurroIcon />
        </li>
        <li>
          <span>Sussuro</span>
        </li>
      </div>
      {/* <div className="popover__dashboard-screen__labels second">
              <li><EyeIcon /></li>
              <li>
                <span>Monitorar</span>
              </li>
            </div> */}
      <div
        className="popover__dashboard-screen__labels second"
        onClick={() =>
          InitialMonitoringAction(
            InfoUsers.id,
            user.iduser,
            user.label,
            MonitoringSimult,
            "3",
            user.ramal,
          )
        }
      >
        <li>
          <PointMessageIcon />
        </li>
        <li>
          <span>Intercalar</span>
        </li>
      </div>
      <div
        className="popover__dashboard-screen__labels second"
        onClick={() =>
          showModal(
            user.iduser,
            user.status_sip,
            user.razao_bloqueio,
            user.duration,
            user.status,
          )
        }
      >
        <li>
          <BlockIcon />
        </li>
        <li>
          <span>Bloquear</span>
        </li>
      </div>
    </div>
  );

  const renderStatus = (
    status,
    status_sip,
    razao_bloqueio,
    descfuturepause,
  ) => {
    if (status === "LV" && status_sip === "LV") {
      return (
        <div className="manager-box-status idle">
          <div className="manager-box-status__circle green"></div>
          <span>Livre</span>
        </div>
      );
    } else if (status === "AT" && status_sip === "AT") {
      return (
        <div className="manager-box-status answer">
          <div className="manager-box-status__circle blue"></div>
          <span>Atendimento</span>
        </div>
      );
    } else if (status === null && status_sip === null) {
      return (
        <div className="manager-box-status offline">
          <div className="manager-box-status__circle gray"></div>
          <span>Inativo</span>
        </div>
      );
    } else if (status === "null" && status_sip === "null") {
      return (
        <div className="manager-box-status offline">
          <div className="manager-box-status__circle gray"></div>
          <span>Inativo</span>
        </div>
      );
    } else if (status === null && status_sip === "LV") {
      return (
        <div className="manager-box-status idle">
          <div className="manager-box-status__circle green"></div>
          <span>Livre</span>
        </div>
      );
    } else if (status === "LV" && status_sip === "BQ") {
      return (
        <div className="manager-box-status block">
          <div className="manager-box-status__circle blue"></div>
          <span>Pausado</span>
        </div>
      );
    } else if (status === "BQ" && status_sip === "BQ") {
      return (
        <Tooltippy content={razao_bloqueio}>
          {razao_bloqueio && (
            <div className="manager-box-status block-reason">
              <div
                className="manager-box-status__circle red"
                style={{
                  marginLeft: razao_bloqueio.length >= 84 ? "4px" : "0px",
                }}
              ></div>
              <span className="manager-box-status__text">{razao_bloqueio}</span>
            </div>
          )}
        </Tooltippy>
      );
    } else if (status === null && status_sip === "BQ") {
      return (
        <Tooltippy content={razao_bloqueio}>
          {razao_bloqueio && (
            <div className="manager-box-status block-reason">
              <div
                className="manager-box-status__circle red"
                style={{
                  marginLeft: razao_bloqueio.length >= 84 ? "4px" : "0px",
                }}
              ></div>
              <span className="manager-box-status__text">{razao_bloqueio}</span>
            </div>
          )}
        </Tooltippy>
      );
    } else if (status_sip === "LV" && status === "AT") {
      return (
        <div className="manager-box-status answer">
          <div className="manager-box-status__circle blue"></div>
          <span>Atendimento</span>
        </div>
      );
    } else if (status_sip === "AT" && status === null) {
      return (
        <div className="manager-box-status answer">
          <div className="manager-box-status__circle blue"></div>
          <span>Atendimento</span>
        </div>
      );
    } else if (status_sip === "CHND" && status != "CHND") {
      return (
        <div className="manager-box-status answer">
          <div className="manager-box-status__circle blue"></div>
          <span>Atendimento</span>
        </div>
      );
    } else if (status === "CHND" && status_sip != "LV") {
      return (
        <div className="manager-box-status answer">
          <div className="manager-box-status__circle blue"></div>
          <span>Atendimento</span>
        </div>
      );
    } else if (status === "ACW" && status_sip === "ACW") {
      return (
        <div className="manager-box-status answer">
          <div className="manager-box-status__circle yellow"></div>
          <span>AfterCallWork</span>
        </div>
      );
    } else if (status_sip === "RV" && status === "ATOS") {
      return (
        <div className="manager-box-status answer">
          <div className="manager-box-status__circle blue"></div>
          <span>Atendimento</span>
        </div>
      );
    } else if (status_sip === "BQSUPER" && status === "BQSUPER") {
      return (
        <div className="manager-box-status answer">
          <div className="manager-box-status__circle red"></div>
          <span>Bloqueado</span>
        </div>
      );
    } else if (status === "RV" && status_sip === "LV") {
      return (
        <div className="manager-box-status answer">
          <div className="manager-box-status__circle blue"></div>
          <span>Atendimento</span>
        </div>
      );
    }

    return "";
  };

  const renderQtdCalls = (status, status_sip, todos) => {
    let temp = [];
    let qtdWhatsapp = 0;
    let qtdFacebook = 0;
    let qtdEmail = 0;
    let qtdWebchat = 0;
    let qtdVoz = 0;
    let qtdTelegram = 0;
    let qtdInstagram = 0;
    let qtdGoogleGBM = 0;
    let qtdTeams = 0;
    let arrayMount = [];
    let qtdWhatsappVoice = 0;

    try {
      let aux = todos.split("¿");
      aux.map((todo) => {
        arrayMount.push({
          CHANNEL: todo.split("§")[0],
          PHONE: todo.split("§")[1],
        });
      });

      arrayMount.map((todo) => {
        if (parseInt(todo.CHANNEL) === 5) qtdWhatsapp = qtdWhatsapp + 1;

        if (parseInt(todo.CHANNEL) === 4) qtdFacebook = qtdFacebook + 1;

        if (parseInt(todo.CHANNEL) === 3) qtdEmail = qtdEmail + 1;

        if (parseInt(todo.CHANNEL) === 2) qtdWebchat = qtdWebchat + 1;

        if (parseInt(todo.CHANNEL) === 1) qtdVoz = qtdVoz + 1;

        if (parseInt(todo.CHANNEL) === 8) qtdTelegram = qtdTelegram + 1;

        if (parseInt(todo.CHANNEL) === 6) qtdInstagram = qtdInstagram + 1;

        if (parseInt(todo.CHANNEL) === 11) qtdGoogleGBM = qtdGoogleGBM + 1;

        if (parseInt(todo.CHANNEL) === 15) qtdTeams = qtdTeams + 1;

        if (parseInt(todo.CHANNEL) === 16)
          qtdWhatsappVoice = qtdWhatsappVoice + 1;
      });
    } catch (error) {
      console.log("Continue");
    }

    if (qtdTelegram > 0) {
      temp.push({
        channel: 8,
        qtd: qtdTelegram,
      });
    }

    if (qtdInstagram > 0) {
      temp.push({
        channel: 6,
        qtd: qtdInstagram,
      });
    }

    if (qtdWhatsapp > 0) {
      temp.push({
        channel: 5,
        qtd: qtdWhatsapp,
      });
    }

    if (qtdFacebook > 0) {
      temp.push({
        channel: 4,
        qtd: qtdFacebook,
      });
    }

    if (qtdEmail > 0) {
      temp.push({
        channel: 3,
        qtd: qtdEmail,
      });
    }

    if (qtdWebchat > 0) {
      temp.push({
        channel: 2,
        qtd: qtdWebchat,
      });
    }

    if (qtdVoz > 0) {
      temp.push({
        channel: 1,
        qtd: qtdVoz,
      });
    }

    if (qtdGoogleGBM > 0) {
      temp.push({
        channel: 11,
        qtd: qtdGoogleGBM,
      });
    }

    if (qtdTeams > 0) {
      temp.push({
        channel: 15,
        qtd: qtdTeams,
      });
    }

    if (qtdWhatsappVoice > 0) {
      temp.push({
        channel: 16,
        qtd: qtdWhatsappVoice,
      });
    }

    return (
      <div className="manager-box-channels">
        {temp.map((todo) => (
          <div className="manager-box-channels__header">
            <div className="manager-box-channels__header-box">
              <span className="manager-box-channels__header-box__legend">
                {todo.qtd}
              </span>
            </div>
            {renderIcon(todo.channel)}
          </div>
        ))}
      </div>
    );
  };

  const renderIcon = (media) => {
    if (media === 5) return <WhatsappIcon />;
    if (media === 4) return <FacebookIcon />;
    if (media === 3) return <EmailIcon width="32" height="32" />;
    if (media === 1) return <VozIcon />;
    if (media === 6) return <InstaIcon />;
    if (media === 8) return <TelegramIcon />;
    if (media === 2) return <WebchatIcon />;
    if (media === 11) return <GOOGLEGBM />;
    if (media === 15) return <TEAMS />;
    if (media === 16) return <WhatsappVoiceIcon width="32" height="32" />;
  };

  useEffect(() => {
    port = localStorage.getItem("port");
    pathname = localStorage.getItem("pathname");
  }, []);

  useEffect(() => {
    let data = [];
    let groupsPermission = [];
    if (FiltersManager.is_active) {
      let beforeIsFilter = usersReduce;
      codeStatus = [];

      beforeIsFilter = beforeIsFilter.filter((filt) =>
        FiltersManager.filter_manager_group.includes(filt.id_grupo),
      );

      let tempIdle = FiltersManager.filter_manager_status.filter(
        (filt) => filt === 1,
      );
      let tempAnswer = FiltersManager.filter_manager_status.filter(
        (filt) => filt === 2,
      );
      let tempReason = FiltersManager.filter_manager_status.filter(
        (filt) => filt === 3,
      );
      let tempBlock = FiltersManager.filter_manager_status.filter(
        (filt) => filt === 4,
      );
      let tempOff = FiltersManager.filter_manager_status.filter(
        (filt) => filt === 5,
      );
      let tempAcw = FiltersManager.filter_manager_status.filter(
        (filt) => filt === 6,
      );

      if (tempIdle.length !== 0) {
        codeStatus.push("LV");
      }

      if (tempAnswer.length !== 0) {
        codeStatus.push("AT", "ATOS", "RV", "CHND");
      }

      if (tempReason.length !== 0) {
        codeStatus.push("BQ");
      }

      if (tempBlock.length !== 0) {
        codeStatus.push("BQSUPER");
      }

      if (tempOff.length !== 0) {
        codeStatus.push("null");
      }

      if (tempAcw.length !== 0) {
        codeStatus.push("ACW");
      }

      groupsPermission = GroupsPermissionSupervisor.map(
        (group) => group.usergroup,
      );

      beforeIsFilter = beforeIsFilter.filter((filt) =>
        codeStatus.includes(filt.status, filt.status_sip),
      );

      beforeIsFilter = beforeIsFilter.filter((filt) =>
        groupsPermission.includes(filt.id_grupo),
      );

      for (const user of beforeIsFilter) {
        let nps = "-";
        let csat = "-";
        let duracao = "";
        let duracaoFPause = "";
        let arrayCompA = user.duration.split("-");
        let datatimeCompA = moment().format("YYYY/MM/DD HH:mm:ss");
        let dataStatusA = moment(arrayCompA[0], "DD/MM/YYYY HH:mm:ss").format(
          "YYYY/MM/DD HH:mm:ss",
        );
        let dataStatusB = "";
        if (
          user.tmfuturepause !== undefined &&
          user.tmfuturepause !== "undefined" &&
          user.tmfuturepause != ""
        ) {
          dataStatusB = moment(
            user.tmfuturepause,
            "DD/MM/YYYY HH:mm:ss",
          ).format("YYYY/MM/DD HH:mm:ss");
        }

        // let TempoTotalPausa     = parseInt(user.psdtma)>0?parseInt(user.psdtma)+parseInt(TempoTotalPausa):parseInt(TempoTotalPausa);
        // let TempoTotalEntrada   = parseInt(user.intmans)>0?parseInt(user.intmans)+parseInt(TempoTotalEntrada):parseInt(TempoTotalEntrada);
        // let TempoTotalSaida     = parseInt(user.outtmans)>0?parseInt(user.outtmans)+parseInt(TempoTotalSaida):parseInt(TempoTotalSaida);
        // let TempoTotalLogado    = parseInt(user.tmlogin)>0?parseInt(user.tmlogin)+parseInt(TempoTotalLogado):parseInt(TempoTotalLogado);

        let TempoTotalPausa =
          parseInt(user.psdtma) > 0 ? parseInt(user.psdtma) : 0;
        let TempoTotalEntrada =
          parseInt(user.intmans) > 0 ? parseInt(user.intmans) : 0;
        let TempoTotalSaida =
          parseInt(user.outtmans) > 0 ? parseInt(user.outtmans) : 0;
        let TempoTotalLogado =
          parseInt(user.tmlogin) > 0 ? parseInt(user.tmlogin) : 0;

        let gdaTotal =
          TempoTotalLogado > 0
            ? [
                100 -
                  (parseInt(
                    TempoTotalPausa + TempoTotalEntrada + TempoTotalSaida,
                  ) /
                    parseInt(TempoTotalLogado)) *
                    100,
              ]
            : 0;
        gdaTotal = parseInt(gdaTotal) > 0 ? gdaTotal : 0;
        let intma = TimeFormat.fromS(
          parseInt(user.tmentrada) > 0 ? parseInt(user.tmentrada) : 0,
          "hh:mm:ss",
        ).split(".");
        let outtma = TimeFormat.fromS(
          parseInt(user.tmsaida) > 0 ? parseInt(user.tmsaida) : 0,
          "hh:mm:ss",
        ).split(".");

        var valorDiferenca = parseInt(
          Math.abs(Math.round(LoginCompleteReducer.difftime)),
        );

        if (parseInt(LoginCompleteReducer.difftime) < 0) {
          datatimeCompA = moment()
            .subtract(valorDiferenca, "seconds")
            .format("YYYY/MM/DD HH:mm:ss");
        } else {
          datatimeCompA = moment()
            .add(valorDiferenca, "seconds")
            .format("YYYY/MM/DD HH:mm:ss");
        }

        duracao = moment(datatimeCompA).diff(dataStatusA, "seconds");
        duracao = duracao < 0 ? 0 : duracao;

        duracaoFPause = moment(datatimeCompA).diff(dataStatusA, "seconds");
        duracaoFPause = duracaoFPause < 0 ? 0 : duracaoFPause;

        if (
          user.satisfaction &&
          user.satisfaction !== null &&
          user.satisfaction !== "Received: INFO"
        ) {
          try {
            let satisfaction = user.satisfaction.split("&&");
            nps = satisfaction[0].split(":")[1];
            csat = satisfaction[1].split(":")[1];
          } catch (error) {
            nps = "-";
            csat = "-";
          }
        }

        data.push({
          attendants: {
            data: (
              <PopoverDashboard
                trigger="click"
                boundary="window"
                placement="top"
                multiple={true}
                interactive={true}
                content={renderHandleActions(user)}
              >
                <div className="container__colaborators-info">
                  <strong>{user.label}</strong>
                  <span>Ramal {user.ramal}</span>
                </div>
              </PopoverDashboard>
            ),
            config: {
              customOrder: user.label,
              className: "cell-gray-text",
              filterValue: "",
              textEllipsis: false,
              customData: false,
              favorite: true,
              read: true,
              filter: "",
            },
          },
          channels: {
            data:
              user.status === null && user.status_sip === null
                ? ""
                : renderQtdCalls(user.status, user.status_sip, user.jsoncall),
            config: {
              className: "",
            },
          },
          future: {
            data: parseInt(user.futurepause) === 1 ? user.descfuturepause : "",
            config: {
              className: "",
            },
          },
          status: {
            data: renderStatus(
              user.status,
              user.status_sip,
              user.razao_bloqueio,
              user.descfuturepause,
            ),
            config: {
              className: "",
            },
          },
          group: {
            // data: (<PopoverDashboard content={renderPopover(user.desc_grupo)}>{user.desc_grupo.substr(0, 13)}</PopoverDashboard>),
            data: (
              <Tooltippy content={user.desc_grupo}>
                {
                  <>
                    <span className="manager-box-status__text">
                      {user.desc_grupo.substr(0, 13)}
                    </span>
                  </>
                }
              </Tooltippy>
            ),

            config: {
              textEllipsis: true,
              className: "cell-blue-text",
            },
          },
          tmr_email: {
            data: "00:00:00",
            config: {
              textEllipsis: true,
            },
          },
          nps: {
            data:
              nps.trim() !== "null" && nps !== null && nps !== "-"
                ? parseInt(nps)
                : "",
            config: {
              textEllipsis: true,
            },
          },
          csat: {
            data:
              csat.trim() !== "null" && csat !== null && csat !== "-"
                ? parseInt(csat)
                : "",
            config: {
              textEllipsis: true,
            },
          },
          reason: {
            data:
              user.psdcount === "Received: INFO" ? 0 : parseInt(user.psdcount),
            config: {
              textEllipsis: true,
            },
          },
          gda: {
            data: parseInt(gdaTotal),
            config: {
              textEllipsis: true,
            },
          },
          in: {
            data:
              user.inanscount === "Received: INFO"
                ? 0
                : parseInt(user.inanscount),
            config: {
              textEllipsis: true,
            },
          },
          tmain: {
            data: intma,
            config: {
              textEllipsis: true,
            },
          },
          out: {
            data:
              user.outanscount === "Received: INFO"
                ? 0
                : parseInt(user.outanscount),
            config: {
              textEllipsis: true,
            },
          },
          tmaout: {
            data: outtma,
            config: {
              textEllipsis: true,
            },
          },
          timepausefuture: {
            data:
              user.tmfuturepause !== undefined &&
              user.tmfuturepause !== "undefined" &&
              user.tmfuturepause !== "" &&
              parseInt(user.futurepause) === 1 ? (
                <TimeCounterMinute
                  horario={parseInt(duracaoFPause)}
                  key={user.iduser + user.status + user.tmfuturepause}
                />
              ) : (
                ""
              ),
            config: {
              textEllipsis: true,
            },
          },
          timestatus: {
            data: (
              <TimeCounterMinute
                horario={parseInt(duracao)}
                key={user.iduser + user.status + duracao}
              />
            ),
            config: {
              textEllipsis: true,
            },
          },
        });
      }
      colaboratorsDataFiltered = data;
      setUsersRefactored(data);
    }
  }, [usersReduce, FiltersManager, GroupsPermissionSupervisor]);

  exhibColumn = [
    {
      title: "Atendentes",
      exhib: columnsAllColaborators.attendants,
    },
    {
      title: "Canais",
      exhib: columnsAllColaborators.channels,
    },
    {
      title: "Pausa Futura",
      exhib: columnsAllColaborators.future,
    },
    {
      title: "Status",
      exhib: columnsAllColaborators.status,
    },
    {
      title: "Grupo",
      exhib: columnsAllColaborators.group,
    },
    {
      title: "TMR E-mail",
      exhib: columnsAllColaborators.tmr_email,
    },
    {
      title: "NPS",
      exhib: columnsAllColaborators.nps,
    },
    {
      title: "CSAT",
      exhib: columnsAllColaborators.csat,
    },
    {
      title: "Pausa",
      exhib: columnsAllColaborators.reason,
    },
    {
      title: "GDA",
      exhib: columnsAllColaborators.gda,
    },
    {
      title: "Q.ATD. Entrada",
      exhib: columnsAllColaborators.in,
    },
    {
      title: "TMA Entrada",
      exhib: columnsAllColaborators.tmain,
    },
    {
      title: "Q.ATD. Saída",
      exhib: columnsAllColaborators.out,
    },
    {
      title: "TMA Saída",
      exhib: columnsAllColaborators.tmaout,
    },
    {
      title: "Tempo Pausa Futura",
      exhib: columnsAllColaborators.timepausefuture,
    },
    {
      title: "Tempo do Status",
      exhib: columnsAllColaborators.timestatus,
    },
  ];

  columns = [
    {
      Header: "Atendentes",
      accessor: "attendants",
      Hint: "Atendentes",
      id: "attendants",
      disableFilters: true,
      sortType: defaultSortingCase,
      display: chooseDisplay("Atendentes"),
    },
    {
      Header: "Canais   ",
      accessor: "channels",
      Hint: "Canais",
      id: "channels",
      disableFilters: true,
      //sortType: defaultSorting,
      display: chooseDisplay("Canais"),
      disableSortBy: true,
    },
    {
      Header: "Pausa Futura",
      accessor: "future",
      Hint: "Pausa Futura",
      id: "future",
      disableFilters: true,
      sortType: defaultSorting,
      display: chooseDisplay("Pausa Futura"),
    },
    {
      Header: "Tempo Pausa Futura",
      accessor: "timepausefuture",
      Hint: "Tempo Pausa Futura",
      id: "timepausefuture",
      disableFilters: true,
      sortType: defaultSorting,
      display: chooseDisplay("Tempo Pausa Futura"),
    },
    {
      Header: "Status",
      accessor: "status",
      Hint: "Status",
      id: "status",
      disableFilters: true,
      //sortType: defaultSorting,
      display: chooseDisplay("Status"),
      disableSortBy: true,
    },
    {
      Header: "Tempo do Status",
      accessor: "timestatus",
      Hint: "Tempo do Status",
      id: "timestatus",
      disableFilters: true,
      sortType: defaultSorting,
      display: chooseDisplay("Tempo do Status"),
    },
    {
      Header: "Grupo",
      accessor: "group",
      Hint: "Grupo",
      id: "group",
      sortType: defaultSorting,
      disableFilters: true,
      display: chooseDisplay("Grupo"),
    },
    {
      Header: "TMR E-mail",
      accessor: "tmr_email",
      Hint: "Tempo médio de resolução de e-mail",
      id: "tmr_email",
      sortType: defaultSorting,
      disableFilters: true,
      display: chooseDisplay("TMR E-mail"),
    },
    {
      Header: "% NPS",
      accessor: "nps",
      Hint: "NPS",
      id: "nps",
      sortType: defaultSorting,
      disableFilters: true,
      display: chooseDisplay("NPS"),
      //disableSortBy: true
    },
    {
      Header: "% CSAT",
      accessor: "csat",
      Hint: "CSAT",
      id: "csat",
      sortType: defaultSorting,
      disableFilters: true,
      display: chooseDisplay("CSAT"),
      //disableSortBy: true
    },
    {
      Header: "Pausa",
      accessor: "reason",
      Hint: "Pausa",
      id: "reason",
      sortType: defaultSorting,
      disableFilters: true,
      display: chooseDisplay("Pausa"),
    },
    {
      Header: "% GDA",
      accessor: "gda",
      Hint: "Grau de disponibilidade do agente",
      id: "gda",
      sortType: defaultSorting,
      disableFilters: true,
      display: chooseDisplay("GDA"),
      //disableSortBy: true
    },
    {
      Header: "Q.ATD. Entrada",
      accessor: "in",
      Hint: "Quantidade de chamadas atendidas na entrada",
      id: "in",
      sortType: defaultSorting,
      disableFilters: true,
      display: chooseDisplay("Q.ATD. Entrada"),
    },
    {
      Header: "TMA Entrada",
      accessor: "tmain",
      Hint: "Tempo médio de atendimento na entrada",
      id: "tmain",
      disableFilters: true,
      sortType: defaultSorting,
      display: chooseDisplay("TMA Entrada"),
    },
    {
      Header: "Q.ATD. Saída",
      accessor: "out",
      Hint: "Quantidade de chamadas atendidas na saída",
      id: "out",
      sortType: defaultSorting,
      disableFilters: true,
      display: chooseDisplay("Q.ATD. Saída"),
    },
    {
      Header: "TMA Saída",
      accessor: "tmaout",
      Hint: "Tempo médio de atendimento na saída",
      id: "tmaout",
      disableFilters: true,
      sortType: defaultSorting,
      display: chooseDisplay("TMA Saída"),
    },
  ];

  let checkSort = localStorage.getItem("sortMarkedColaborators")
    ? JSON.parse(localStorage.getItem("sortMarkedColaborators"))
    : "";

  let sortBy = {
    sortBy: [],
  };

  if (checkSort !== "") {
    sortBy = {
      sortBy: [
        {
          id: checkSort ? checkSort.sort : "attendants",
          desc: checkSort ? checkSort.sortDesc : false,
        },
      ],
    };
  }

  return (
    <div className="manager-component__card-table">
      <div className="manager-component__card-table__box">
        <div className="manager-component__card-table__title">
          <TextMedium text={title} color="gray" />
        </div>
        <PopoverColumnsFilter
          className={"filters-columns"}
          placement="bottom-end"
          menuData={exhibColumn}
          screen="manager_colaborators"
        >
          <div className="email__container-subheader__actionsTwo">
            <ColumnFilterIcon />
            <span className="email__container-subheader__actionsTwo-span">
              Colunas
            </span>
          </div>
        </PopoverColumnsFilter>
      </div>
      <div className="manager-component__card-table__area">
        {LoginCompleteReducer.isLoginComplete ? (
          colaboratorsDataFiltered.length !== 0 ? (
            <Table
              className="table-cases"
              data={colaboratorsDataFiltered}
              columns={columns}
              fixedHeader
              // fixedFirstColumn
              // filtersActive={filtersActive}
              // emptyState={emptyState}
              // setEmptyState={setEmptyState}
              initialState={sortBy}
              screen="manager_colaborators"
            />
          ) : (
            <div className="manager-component__card-table__area-empty">
              <EmptyState />
            </div>
          )
        ) : (
          <img src={LoadingTable} alt="loading" />
        )}
      </div>
      <BlockUnBlockUserModal
        duration={duration}
        userout={userout}
        reasonaction={reasonaction}
        horaaction={horaaction}
        act={act}
        actdesb={actdesb}
        setActDesb={setActDesb}
        inable={inable}
        setAct={setAct}
        idblock={idblock}
        idsup={idsup}
      />
    </div>
  );
}
